/**
 * Shows Page.
 */
import MainTemplate from '../templates/main/ui/main';
import useSection from '@shared/components/utils/hooks/useSection';
import { QuerySections } from '@shared/types/enums/sections';

/**
 * Shows page component that displays shows content with highlights and reels.
 * Starts navigation in menu
 */
export default function ShowsPage() {
  const { complete, highlights, reels, onPagination } = useSection({
    section: QuerySections.SHOWS,
  });
  return (
    <MainTemplate
      rails={reels}
      sliders={highlights}
      flags={{ complete }}
      onPagination={onPagination}
    />
  );
}
